import { CancelOutlined, CheckOutlined } from '@mui/icons-material';
import { Box, CircularProgress, Link, Stack, Typography } from '@mui/material';
import GoogleButton from 'react-google-button';
import { useLanguage } from '../context/language.context';
import useFetch from '../hooks/useFetch';

const GoogleCalendar = ({
  linked,
  onButtonClicked,
  checkSyncURL,
}: {
  linked: boolean;
  onButtonClicked: () => void;
  checkSyncURL: string;
}) => {
  const sync = useFetch<{ available: number }>(checkSyncURL);
  const available = sync.data?.available;
  const { t } = useLanguage();

  return (
    <Box display='flex' flexDirection='column' alignItems='center' gap={2} p={3}>
      <Typography textAlign={'center'} maxWidth={600}>
        {t('googleCalendarDescription')}
      </Typography>
      <Typography textAlign={'center'} fontSize={14} maxWidth={600}>
        {t('googleCalendarPolicy')}{' '}
        <Link href='https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes'>
          {t('googleCalendarPolicyLink')}
        </Link>
        , including the Limited Use requirements
      </Typography>

      <GoogleButton onClick={onButtonClicked} />
      {available ? (
        <Stack display='flex' direction={'column'} alignItems='center' gap={2}>
          {available === 200 ? <CheckOutlined color='success' /> : <CancelOutlined color='error' />}
          <Typography
            style={{ whiteSpace: 'pre-wrap' }}
            textAlign='center'
            fontWeight={600}
            color={available === 200 ? 'black' : 'error'}>
            {available === 200
              ? t('connected')
              : available === 405
              ? t('syncFailed')
              : t('notConnected')}
          </Typography>
        </Stack>
      ) : sync.loading ? (
        <CircularProgress size={20} />
      ) : null}
    </Box>
  );
};

export default GoogleCalendar;
